<template>
  <ModalDialog
    ref="dialog"
    title="Edit Stocktake"
    icon="fa-warehouse-alt"
    :submitting="submitting"
    submitTitle="Update"
    @closed="onClosed"
    @submitted="onSubmitted">

    <Spinner v-if="loading" />
    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3" v-show="!loading">
      <FormRow label="Stocktake Name">
        <FormInputText v-model="stockTake.name" field="name" placeholder="Stocktake Name" />
      </FormRow>
      <FormRow label="Assigned Users" helpTip="These users all have access to the stocktake to submit counts">
        <FormMultiSelect :options="userList" v-model="selectedUsers" placeholder="Users" field="users" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>


<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'StocktakeEditDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    stockId: Number
  },
  data() {
    return {
      loading: false,
      stockTake: { },
      dialogForm: {},
      selectedUsers: [],
      userList: [],
      submitting: false
    }
  },
  created() {
  },
  mounted() {
    this.requestData()
  },
  computed: {

  },
  methods: {
    show(stockTake) {
      // Reset form
      this.stockTake = _.cloneDeep(stockTake || {})
      this.dialogForm = {}
      this.submitting = false

      // Set selected users
      if(this.stockTake && this.stockTake.assignedUsers) {
        this.selectedUsers = this.stockTake.assignedUsers.map(user => user.id)
      }

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      let updateData = {
        name: this.stockTake.name,
        users: this.selectedUsers
      }

      this.$apiService.inventoryService.updateStocktake(this.stockTake.id, updateData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.$data.dialogForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.$data.submitting = false
      })
    },
    requestData() {
      this.loading = true

      this.$apiService.userService.getUserList()
      .then(response => {
        this.userList = response.data.map(user => {
          return {
            value: user.id,
            name: user.name,
            colour: user.highlightColour
          }
        })
      })
      .catch(err => {
        this.displayNetworkError(err, 'Error loading user list')
      })
      .finally(() => {
        this.loading = false
      })       

    }
  }
}
</script>